export default "__VITE_ASSET__CXEL4og0__"